import { Directive, inject } from '@angular/core';
import { Location } from '@angular/common';

@Directive({
    selector: '[xuiBackButton]',
    host: {
      '(click)': 'onClick()'
    }
})
export class BackButtonDirective {
    private location = inject(Location);

    onClick() {
        this.location.back();
    }
}
